import React, { FunctionComponent } from "react";
import { renderMultiSelectLabel } from "@iventis/components";
import { StyledTextCell } from "../styles/data-table.styles";
import { ListItemCellComponentProps, ListItem } from "../types/data-table.types";

/**
 * Used as cellRenderer for data table column of type "multi_select"
 */
export const MultiSelectCellComponent: FunctionComponent<ListItemCellComponentProps> = ({ value, context }) => {
    // eslint-disable-next-line react/destructuring-assignment
    const translate = context?.translate;
    return (
        <StyledTextCell>
            {Array.isArray(value) && value.length > 0 ? renderMultiSelectLabel<ListItem>(value, { translate }) : ""}
        </StyledTextCell>
    );
};
